import { ReactElement } from 'react'

import { Flex } from 'components/core'
import { SELLER_BRAND_TYPE } from 'const/brands'
import { Campaign } from 'types'

import CreateProductAdFormAllRow from './CreateProductAdFormAllRow'
import CreateProductAdFormHeader from './CreateProductAdFormHeader'
import CreateProductAdFormRow from './CreateProductAdFormRow'
import { ProductAdField } from './localTypes'
import * as styles from './styles.scss'

interface Props {
    campaign: Campaign
    products: ProductAdField[]
    remove: (index: number) => void
    setFieldValue: (name: string, values: any) => void
}

const CreateProductAdForm = ({
    campaign,
    products = [],
    remove,
    setFieldValue,
}: Props): ReactElement => {
    const isSellerBrandType = campaign?.profile.type === SELLER_BRAND_TYPE
    const buttonLabel = isSellerBrandType ? 'SKU' : 'ASIN'

    return (
        <Flex
            direction="column"
            marginTop={8}
            style={{ flexShrink: 0 }}
            alignItems="normal"
        >
            {products.length > 0 ? (
                <div>
                    <CreateProductAdFormHeader type={buttonLabel} />
                    <CreateProductAdFormAllRow
                        campaign={campaign}
                        products={products}
                        setFieldValue={setFieldValue}
                    />
                    {products.map((product, idx) => (
                        <CreateProductAdFormRow
                            campaign={campaign}
                            key={idx}
                            product={product}
                            productIndex={idx}
                            remove={remove}
                        />
                    ))}
                </div>
            ) : (
                <div
                    className={styles['empty-table-text']}
                    style={{ marginTop: 8, padding: 12 }}
                >
                    To get started, add some Product Ad {buttonLabel}s in the
                    field above
                </div>
            )}
        </Flex>
    )
}

export default CreateProductAdForm
